(function () {
  const observedSections = new WeakMap();

  function bindResponsiveProductMedia(section) {
    if (!section || observedSections.has(section)) return;
    if (!section.querySelector(".product__main")) return;

    let isSliderActive = null;

    function reinitIfLayoutModeChanged() {
      if (typeof window.reinitProductMedia !== "function") return;

      if (typeof window.shouldUseProductMediaSlider === "function") {
        const shouldUseSlider = window.shouldUseProductMediaSlider(section);
        if (shouldUseSlider === isSliderActive) return;
        isSliderActive = shouldUseSlider;
      }

      window.reinitProductMedia(section);
    }

    const resizeObserver = new ResizeObserver(reinitIfLayoutModeChanged);

    resizeObserver.observe(section);
    observedSections.set(section, resizeObserver);

    reinitIfLayoutModeChanged();
  }

  document.addEventListener("shopify:section:load", function (e) {
    bindResponsiveProductMedia(e.target);
  });

  bindResponsiveProductMedia(document.currentScript?.parentElement);
})();
